import { render, staticRenderFns } from "./BlueProjectsIndex.vue?vue&type=template&id=3d4e09ae&lang=pug&"
import script from "./BlueProjectsIndex.vue?vue&type=script&lang=js&"
export * from "./BlueProjectsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports